// @flow

import Relay from 'react-relay/classic';
import fromGraphQL from 'react-relay/lib/fromGraphQL';


const QUERIES = {
  "build_header/build": Relay.QL`
    query BuildsShowBuild($build: ID!) {
      build(slug: $build) {
        id
        createdBy {
          __typename
          ...on UnregisteredUser {
            name
            email
            avatar {
              url
            }
          }
          ...on User {
            id
            name
            email
            avatar {
              url
            }
          }
        }
      }
    }
  `,
  "organization_show/organization": Relay.QL`
    query PipelinesList($organization: ID!, $team: TeamSelector, $pageSize: Int, $pipelineFilter: String) {
      organization(slug: $organization) {
        id
        slug
        name
        permissions {
          pipelineCreate {
            code
            allowed
            message
          }
        }
        teams(first: 100) {
          edges {
            node {
              id
              name
              slug
              description
              permissions {
                pipelineView {
                  allowed
                }
              }
            }
            cursor
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
        }
        allPipelines: pipelines(team: $team) {
          count
       }
        pipelines(first: $pageSize, search: $pipelineFilter, team: $team, order: NAME_WITH_FAVORITES_FIRST) {
          edges {
            node {
              id
              name
              slug
              description
              url
              favorite
              defaultBranch
              permissions {
                pipelineFavorite {
                  allowed
                }
              }
              metrics(first: 6) {
                edges {
                  node {
                    label
                    value
                    url
                    id
                  }
                  cursor
                }
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                }
              }
              builds(first: 1, branch: "%default", state: [ RUNNING, CANCELING, PASSED, FAILED, CANCELED, BLOCKED ]) {
                edges {
                  node {
                    id
                    message
                    url
                    commit
                    state
                    startedAt
                    finishedAt
                    canceledAt
                    scheduledAt
                    pipeline {
                      commitShortLength
                    }
                    createdBy {
                      __typename
                      ... on User {
                        id
                        name
                        avatar {
                          url
                        }
                      }
                      ...on UnregisteredUser {
                        name
                        avatar {
                          url
                        }
                      }
                    }
                  }
                  cursor
                }
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                }
              }
            }
            cursor
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
        }
      }
    }
  `,
  "navigation/organization": Relay.QL`
    query NavigationOrganization($organization: ID!) {
      organization(slug: $organization) {
        name
        id
        slug
        iconUrl
        agents {
          count
        }
        permissions {
          pipelineView {
            allowed
            code
          }
          agentView {
            allowed
          }
          organizationMemberView {
            allowed
            code
          }
          organizationUpdate {
            allowed
          }
          organizationInvitationCreate {
            allowed
          }
          notificationServiceUpdate {
            allowed
          }
          portalUpdate {
            allowed
          }
          organizationBillingUpdate {
            allowed
          }
          teamView {
            allowed
          }
        }
      }
    }
  `,
  "navigation/viewer": Relay.QL`
    query NavigationViewer {
      viewer {
        id
        user {
          name,
          avatar {
            url
          }
          id
        }
      }
    }
  `,
  "agents/index": Relay.QL`
    query AgentIndex($organization: ID!) {
      organization(slug: $organization) {
        id
        permissions {
          agentTokenView {
            allowed
          }
        }
        agentTokens(first:50, revoked:false) {
          edges {
            node {
              id
              description
              public
              token
            }
            cursor
          },
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
        }
      }
    }
  `,
  "cluster_queues/show": Relay.QL`
    query ClusterQueueAgents($organization: ID!, $search: String, $clusterQueue: [ID!], $pageSize: Int) {
      organization(slug: $organization) {
        allAgents: agents {
          count
        }
        agents(first: $pageSize, search: $search, clusterQueue: $clusterQueue) {
          count
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              id
              hostname
              metaData
              name
              organization {
                slug
              }
              clusterQueue {
                identifier
                cluster {
                  uuid
                  name
                }
              }
              public
              connectionState
              isRunningJob
              job {
                ...on JobTypeCommand {
                  state
                  url
                  label
                  command
                  build {
                    number
                    pipeline {
                      name
                    }
                  }
                }
              }
              uuid
              version
              versionHasKnownIssues
            }
          }
        }
      }
    }
  `,
  /* eslint-enable graphql/no-deprecated-fields */
  "teams/index": Relay.QL`
    query($organization: ID!) {
      organization(slug: $organization) {
        id
        name
        slug
        permissions {
          teamView {
            allowed
            code
            message
          }
          teamEnabledChange {
            allowed
            code
            message
          }
          teamCreate {
            allowed
          }
        }
      }
    }
  `,
  "sso/index": Relay.QL`
    query($organization: ID!) {
      organization(slug: $organization) {
        id
        name
        slug
        permissions {
          organizationUpdate {
            allowed
          }
        }
      }
    }
  `,
  "pipeline/header/build": Relay.QL`
    query($buildSlug: ID!) {
      build(slug: $buildSlug) {
        id
        branch
        commit
      }
    }
  `,
  "pipeline/header": Relay.QL`
    query($pipeline: ID!) {
      pipeline(slug: $pipeline) {
        id
        name
        description
        url
        visibility
        slug
        defaultBranch
        organization {
          name
          slug
          iconUrl
          id
        }
        repository {
          url
          provider {
            __typename
            url
          }
        }
        builds {
          count
        }
        scheduledBuilds: builds(state: SCHEDULED) {
          count
        }
        runningBuilds: builds(state: RUNNING) {
          count
        }
        permissions {
          pipelineUpdate {
            allowed
            code
            message
          }
          buildCreate {
            allowed
            code
            message
          }
        }
      }
    }
  `,
  "pipeline/teams_settings": Relay.QL`
    query($pipeline: ID!) {
      pipeline(slug: $pipeline) {
        id
        slug
        name
        organization {
          id
          slug
        }
        teams(first: 500) {
          count
          edges {
            node {
              id
              accessLevel
              team {
                id
                name
                description
                slug
                members {
                  count
                }
                pipelines {
                  count
                }
              }
              permissions {
                teamPipelineUpdate {
                  allowed
                }
                teamPipelineDelete {
                  allowed
                }
              }
            }
          }
        }
      }
    }
  `,
  "build_show/annotations": Relay.QL`
    query BuildAnnotations($build: ID!) {
      build(slug: $build) {
        id
        annotations(first: 10) {
          edges {
            node {
              id
              context
              style
              body {
                html
              }
            }
            cursor
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
        }
      }
    }
  `,
  "graphql_console/snippet": Relay.QL`
    query GraphQLSnippet($uuid: String!) {
      graphQLSnippet(uuid: $uuid) {
        query
        operationName
        url
      }
    }
  `,
  "totp/viewer": Relay.QL`
    query TOTPViewer {
      viewer {
        id
        permissions {
          totpConfigure {
            allowed
            code
            message
          }
        }
        totp {
          id
          verified
          recoveryCodes {
            id
            active
            codes {
              code
              consumed
            }
          }
        }
      }
    }
  `
};

class RelayPreloader {
  preload(id: string, payload: Object, variables: Object) {
    // Get the concrete query
    const concrete = QUERIES[id];
    if (!concrete) {
      throw new Error(`No concrete query defined for \`${id}\``);
    }

    // Create a Relay-readable GraphQL query with the variables loaded in
    const query = fromGraphQL.Query(concrete);
    query.__variables__ = variables;

    // Load it with the payload into the Relay store
    Relay.Store.getStoreData().handleQueryPayload(query, payload);
  }
}

export default new RelayPreloader();
